import * as React from 'react'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'
import {AISolutionDetailLayout} from '@components/ai'

const Meta = dynamic(() => import('@components/Meta'))

export default function Food() {
  return (
    <React.Fragment>
      <Meta title={`Food | Datawow – ${t('layout.title')}`} />

      <section className='AISolutionDetail__introduction'>
        <div className='container'>
          <div className='grid grid--max-left'>
            <h1>
              <small>ตัวอย่าง AI Use Case ทางด้าน</small>
              Food
            </h1>
            <div>
              <p>
                AI ได้เข้ามามีส่วนในอุตสาหกรรมอาหาร ทั้งในสายการผลิต
                ตั้งแต่ด้านการควบคุมคุณภาพของวัตถุดิบระหว่างกระบวนการผลิตและการส่งออก
                ความสะอาดของอุปกรณ์และตัวเจ้าหน้าที่
                รวมไปถึงการให้บริการในธุรกิจร้านอาหาร
                เพื่อวิเคราะห์พฤติกรรมและความต้องการของลูกค้าซึ่งเปลี่ยนแปลงอย่างรวดเร็ว
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__feature-img'>
        <img
          src='/images/ai/food/feature1.jpg'
          srcSet='/images/ai/food/feature1@2x.jpg 2x'
          alt='Food'
        />
      </section>

      <section className='AISolutionDetail__section'>
        <div className='container'>
          <div className='grid grid--max-right'>
            <div>
              <h2>ตัวอย่างการใช้ AI ใน Food Sorting</h2>
              <p>
                ในสายการผลิตของอุตสาหกรรมอาหาร หนึ่งในขั้นตอนที่ใช้เวลามากที่สุด
                คือการคัดขนาดและจัดเรียงวัตถุดิบเพื่อเข้าสู่กระบวนการแปรรูป
                หรือบรรจุในบรรจุภัณฑ์
                ลักษณะของวัตถุดิบที่แตกต่างกันจะมีผลต่อมุมมองของผู้ซื้อ เช่น
                ผู้บริโภคมักชอบผลไม้ที่สีสดและสม่ำเสมอในบรรจุภัณฑ์เดียวกัน ซึ่ง
                ณ ปัจจุบันยังจำเป็นต้องใช้คนในการคัดแยกและบรรจุ การนำ AI
                เข้ามาเพื่อวิเคราะห์สี และพื้นผิวของผลไม้และจัดเรียง
                จะช่วยลดเวลาในการบรรจุ และลดแรงงานคนได้อีกด้วย
              </p>
            </div>
            <img
              src='/images/ai/food/feature2.jpg'
              srcSet='/images/ai/food/feature2@2x.jpg 2x'
              alt='Food'
              loading='lazy'
              className='lg'
            />
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__section AISolutionDetail__section--light'>
        <div className='container'>
          <h2>
            ตัวอย่างการใช้ AI ใน<span>Anomaly Detection</span>
          </h2>

          <div className='grid grid--max-left'>
            <img
              src='/images/ai/food/feature3.jpg'
              srcSet='/images/ai/food/feature3@2x.jpg 2x'
              alt='Food'
              loading='lazy'
              className='lg'
            />

            <p>
              อีกตัวอย่างที่น่าสนใจของการนำ AI มาใช้ในสายการผลิตคือ
              กรณีของมันฝรั่งหั่นเต๋าสำหรับเด็กของบริษัท Kewpie
              ซึ่งถูกควบคุมด้วยเกณฑ์ที่เข้มงวด
              มันฝรั่งจึงจำเป็นต้องถูกตรวจสอบว่ามีความผิดปกติหรือไม่
              ก่อนนำไปวางขาย
              ซึ่งขั้นตอนนี้เป็นจุดคอขวดที่ต้องใช้เวลาตรวจสอบอย่างละเอียด
              ทางบริษัทจึงได้นำ AI เข้ามาทำหน้าที่เป็น Anomaly Detector
              โดยหลังจากการติดตั้ง พบว่าระบบสามารถตรวจจับความผิดปกติได้
              ถึงแม้ตัวมันฝรั่งจะถูกลำเลียงด้วยสายพานความเร็วสูงก็ตาม
              โดยทางบริษัทมีแผนที่จะนำ AI ไปใช้กับสายการผลิตวัตถุดิบอื่น ๆ เช่น
              ไข่ และธัญพืช
            </p>
          </div>

          <img
            src='/images/ai/food/feature3.jpg'
            srcSet='/images/ai/food/feature3@2x.jpg 2x'
            alt='Food'
            loading='lazy'
            className='sm'
          />
        </div>
      </section>

      <section className='AISolutionDetail__card'>
        <div className='container'>
          <h2>ตัวอย่างการใช้ AI ใน Workplace Sanitary</h2>
          <div className='AISolutionDetail__card__body'>
            <div>
              <p>
                สุขอนามัยของเจ้าหน้าที่ผู้ปฏิบัติงานในกระบวนการผลิตก็เป็นสิ่งที่ต้องคำนึงถึง
                ยิ่งในสถานการณ์การแพร่ระบาดของ Covid-19
                ข้อบังคับด้านความสะอาดและมาตรการ Social Distancing ทำให้ในทุก ๆ
                ขั้นตอนการผลิตต้องถูกตรวจสอบ
                แต่ในขณะเดียวกันก็จำเป็นต้องลดจำนวนคนเพื่อลดการสัมผัส การนำ AI
                ซึ่งเป็นระบบอัตโนมัติเข้ามาใช้จึงสามารถทำให้แน่ใจว่าผู้ปฎิบัติงานใส่หน้ากาก
                ถุงมือ หรืออุปกรณ์อื่น ๆ ระหว่างปฏิบัติงาน
                และผ่านข้อจำกัดด้านจำนวนคนอีกด้วย ตัวอย่างของการนำ AI
                มาใช้ในเรื่องของความสะอาดเช่น บริษัท KanKan ที่นำกล้องพร้อม AI
                ไปใช้ในสายการผลิตอาหาร หรือ ในปี 2020 บริษัท Dragontail systems
                ได้ให้บริการในลักษณะเดียวกันกับร้านอาหาร ระหว่างการระบาดของ
                Covid-19 โดยทำการติดทั้งหน้าร้าน และหลังร้าน
                เพื่อติดตามผู้ปฎิบัติงานผ่านใบหน้าว่าแต่งกายถูกต้องหรือไม่เพื่อสร้างความมั่นใจให้กับผู้บริโภคว่าอาหารของร้านสะอาด
                และปลอดเชื้อ
              </p>
            </div>

            <img
              src='/images/ai/food/feature4.jpg'
              srcSet='/images/ai/food/feature4@2x.jpg 2x'
              loading='lazy'
              alt='Food'
            />
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__section AISolutionDetail__section--dark'>
        <div className='container'>
          <h2>Other use cases</h2>

          <div className='grid grid--max-left'>
            <img
              src='/images/ai/food/feature5.jpg'
              srcSet='/images/ai/food/feature5@2x.jpg 2x'
              alt='Food'
              loading='lazy'
              className='lg'
            />
            <div>
              <p>
                นวัตกรรมข้างต้นเป็นตัวอย่างของการประยุกต์นำ Computer Vision AI
                ซึ่งทำงานเกี่ยวกับรูปภาพรวมเข้ากับเครื่องจักร
                และกล้องวงจรปิดแต่ดั้งเดิม
                เพื่อช่วยเพิ่มประสิทธิภาพในแต่ละขั้นตอนลดต้นทุนคนและเวลา
                และควบคุมให้พนักงานปฏิบัติตามข้อบังคับ ทั้งนี้เรายังสามารถนำ AI
                มาประยุกต์ใช้ร่วมกับการวิเคราะห์ข้อมูลเพื่อสร้างผลตอบแทนทางธุรกิจได้
                เช่น การใช้ AI ร่วมกับเทคนิค Data Mining
                เพื่อเสนอเมนูอาหารที่ตรงใจลูกค้า รวมทั้งการคิดค้นเมนูใหม่
                หรือการนำ AI ไปใช้ใน Supply Chain เพื่อจัดการคลังวัตถุดิบ
                ลดการสูญเสีย และคอยติดตามเส้นทางของวัตถุดิบ
                เพื่อสร้างความโปร่งใสของเส้นทางวัตุดิบตั้งแต่ถูกเก็บเกี่ยวจนถึงมือผู้บริโภค
              </p>
            </div>
          </div>

          <img
            src='/images/ai/food/feature5.jpg'
            srcSet='/images/ai/food/feature5@2x.jpg 2x'
            alt='Food'
            loading='lazy'
            className='sm'
          />
        </div>
      </section>
    </React.Fragment>
  )
}

Food.getLayout = function getLayout(page: React.ReactElement) {
  return <AISolutionDetailLayout>{page}</AISolutionDetailLayout>
}
